// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { _createAiEnvelope, aiMethod } from "./aiSupport";
import { _createOneDsEnvelope, oneDsMethods } from "./1dsSupport";
(function (win, doc) {
    var isOneDS = false; // place holder, will be removed during runtime
    var UInt32Mask = 0x100000000;
    var locn = win.location;
    var helpLink = "https://go.microsoft.com/fwlink/?linkid=2128109";
    var scriptText = "script";
    var strInstrumentationKey = "instrumentationKey";
    var strIngestionendpoint = "ingestionendpoint";
    var strDisableExceptionTracking = "disableExceptionTracking";
    var strToLowerCase = "toLowerCase";
    var strConStringIKey = strInstrumentationKey[strToLowerCase]();
    var strEmpty = "";
    var strUndefined = "undefined";
    var strCrossOrigin = "crossOrigin";
    var strJsonResponseError = "Error Loading JSON response";
    var strPostMethod = "POST";
    var strGetMethod = "GET";
    var policyName = cfg.pn || "aiPolicy";
    var _sequence = 0;
    var _epoch = 0;
    var sdkInstanceName;
    var aiName;
    if (isOneDS) {
        sdkInstanceName = "onedsSDK";
        aiName = cfg.name || "oneDSWeb"; // provide non default instance name through snipConfig name value
    }
    else {
        sdkInstanceName = "appInsightsSDK";
        aiName = cfg.name || "appInsights";
    }
    if (cfg.name || win[sdkInstanceName]) {
        // Only set if supplied or another name is defined to avoid polluting the global namespace
        win[sdkInstanceName] = aiName;
    }
    var aiSdk = win[aiName] || (function (aiConfig, aiExtensions) {
        var targetSrc = aiConfig["url"] || cfg.src;
        var loadFailed = false;
        var handled = false;
        var appInsights = {
            initialize: true,
            queue: [],
            sv: "9",
            config: aiConfig,
            version: 2.0,
            extensions: aiExtensions
        };
        if (isOneDS && !aiConfig["webAnalyticsConfiguration"]) {
            aiConfig["webAnalyticsConfiguration"] = {};
        }
        function isIE() {
            var nav = navigator;
            if (nav) {
                var userAgent = (nav.userAgent || "").toLowerCase();
                return (userAgent.indexOf("msie") !== -1 || userAgent.indexOf("trident/") !== -1);
            }
            return false;
        }
        function _parseConnectionString() {
            var fields = {};
            var connectionString = aiConfig.connectionString;
            if (typeof connectionString === "string" && connectionString) {
                var kvPairs = connectionString.split(";");
                for (var lp = 0; lp < kvPairs.length; lp++) {
                    var kvParts = kvPairs[lp].split("=");
                    if (kvParts.length === 2) { // only save fields with valid formats
                        fields[kvParts[0][strToLowerCase]()] = kvParts[1];
                    }
                }
            }
            // apply the default endpoints
            if (!fields[strIngestionendpoint]) {
                // use endpoint suffix where overrides are not provided
                var endpointSuffix = fields.endpointsuffix;
                // Only fetch the location if a suffix was supplied
                var fLocation = endpointSuffix ? fields.location : null;
                fields[strIngestionendpoint] = "https://" + (fLocation ? fLocation + "." : strEmpty) + "dc." + (endpointSuffix || "services.visualstudio.com");
            }
            return fields;
        }
        function _sendEvents(evts, endpointUrl) {
            if (JSON) {
                var sender = win.fetch;
                if (sender && !cfg.useXhr) {
                    sender(endpointUrl, { method: strPostMethod, body: JSON.stringify(evts), mode: "cors" });
                }
                else if (XMLHttpRequest) {
                    // IE doesn't support fetch and private clouds may only be using IE
                    var xhr = new XMLHttpRequest();
                    xhr.open(strPostMethod, endpointUrl);
                    xhr.setRequestHeader("Content-type", "application/json");
                    xhr.send(JSON.stringify(evts));
                }
            }
        }
        function _reportFailure(targetSrc) {
            if (cfg.dle === true) {
                return;
            }
            var iKey;
            var endpointUrl;
            if (isOneDS) {
                endpointUrl = aiConfig.endpointUrl || "https://browser.events.data.microsoft.com/OneCollector/1.0/";
                iKey = aiConfig["instrumentationKey"] || "";
                var channelConfig = aiConfig["channelConfiguration"];
                if (channelConfig) {
                    endpointUrl = channelConfig.overrideEndpointUrl || endpointUrl;
                    iKey = channelConfig["overrideInstrumentationKey"] || iKey;
                }
                var dt = Date;
                var now = void 0;
                if (dt.now) {
                    now = dt.now();
                }
                else {
                    now = new dt().getTime();
                }
                endpointUrl = endpointUrl + "?cors=true&content-type=application/x-json-stream&client-id=NO_AUTH&client-version=" + appInsights.sv + "&apikey=" + iKey + "&w=0&upload-time=" + now.toString();
            }
            else {
                var conString = _parseConnectionString();
                iKey = conString[strConStringIKey] || aiConfig[strInstrumentationKey] || strEmpty;
                var ingest = conString[strIngestionendpoint];
                if (ingest && ingest.slice(-1) === "/") {
                    ingest = ingest.slice(0, -1);
                }
                endpointUrl = ingest ? ingest + "/v2/track" : aiConfig.endpointUrl; // only add /v2/track when from connectionstring
                endpointUrl = aiConfig.userOverrideEndpointUrl ? aiConfig.userOverrideEndpointUrl : endpointUrl;
            }
            var message = "SDK LOAD Failure: Failed to load Application Insights SDK script (See stack for details)";
            var evts = [];
            evts.push(_createException(iKey, message, targetSrc, endpointUrl));
            if (!isOneDS) {
                evts.push(_createInternal(iKey, message, targetSrc, endpointUrl));
            }
            _sendEvents(evts, endpointUrl);
        }
        function _createEnvelope(iKey, theType) {
            if (_epoch === 0) {
                _epoch = Math.floor((UInt32Mask * Math.random()) | 0) >>> 0;
            }
            if (isOneDS) {
                return _createOneDsEnvelope(iKey, theType, _epoch, _sequence, appInsights.sv);
            }
            else {
                return _createAiEnvelope(iKey, theType, appInsights.sv, appInsights.version, locn);
            }
        }
        function _createInternal(iKey, message, targetSrc, endpointUrl) {
            var envelope = _createEnvelope(iKey, "Message");
            var data = envelope.data;
            data.baseType = "MessageData";
            var baseData = data.baseData;
            baseData.message = "AI (Internal): 99 message:\"" + (message + " (" + targetSrc + ")").replace(/\"/g, strEmpty) + "\"";
            baseData.properties = {
                endpoint: endpointUrl
            };
            return envelope;
        }
        function _createException(iKey, message, targetSrc, endpointUrl) {
            var envelope;
            if (isOneDS) {
                envelope = _createEnvelope(iKey, "Ms.Web.ClientError");
            }
            else {
                envelope = _createEnvelope(iKey, "Exception");
            }
            var data = envelope.data;
            data.baseType = "ExceptionData";
            data.baseData.exceptions = [{
                    typeName: "SDKLoadFailed",
                    message: message.replace(/\./g, "-"),
                    hasFullStack: false,
                    stack: message + "\nSnippet failed to load [" + targetSrc + "] -- Telemetry is disabled\nHelp Link: " + helpLink + "\nHost: " + (locn && locn.pathname || "_unknown_") + "\nEndpoint: " + endpointUrl,
                    parsedStack: []
                }];
            return envelope;
        }
        var domainRetryIndex = -1;
        var domainRetryCount = 0;
        var domains = [
            "js.monitor.azure.com",
            "js.cdn.applicationinsights.io",
            "js.cdn.monitor.azure.com",
            "js0.cdn.applicationinsights.io",
            "js0.cdn.monitor.azure.com",
            "js2.cdn.applicationinsights.io",
            "js2.cdn.monitor.azure.com",
            "az416426.vo.msecnd.net" // this domain is supported but not recommended
        ];
        var fallback = function () { return setScript(targetSrc, null); };
        if (cfg.sri) {
            var match_1 = targetSrc.match(/^((http[s]?:\/\/.*\/)\w+(\.\d+){1,5})\.(([\w]+\.){0,2}js)$/);
            if (match_1 && match_1.length === 6) {
                var integrityUrl = "".concat(match_1[1], ".integrity.json");
                var targetType_1 = "@".concat(match_1[4]);
                var sender = window.fetch;
                var handleResponse_1 = function (json) {
                    if (!json.ext || !json.ext[targetType_1] || !json.ext[targetType_1].file) {
                        throw new Error(strJsonResponseError);
                    }
                    var integrity = json.ext[targetType_1].integrity || null;
                    targetSrc = match_1[2] + json.ext[targetType_1].file;
                    setScript(targetSrc, integrity);
                };
                if (sender && !cfg.useXhr) {
                    sender(integrityUrl, { method: strGetMethod, mode: "cors" })
                        .then(function (response) { return response.json().catch(function () { return ({}); }); })
                        .then(handleResponse_1)
                        .catch(fallback);
                }
                else if (XMLHttpRequest) {
                    var xhr_1 = new XMLHttpRequest();
                    xhr_1.open(strGetMethod, integrityUrl);
                    xhr_1.onreadystatechange = function () {
                        if (xhr_1.readyState === XMLHttpRequest.DONE) {
                            if (xhr_1.status === 200) {
                                try {
                                    handleResponse_1(JSON.parse(xhr_1.responseText));
                                }
                                catch (_a) {
                                    fallback();
                                }
                            }
                            else {
                                fallback();
                            }
                        }
                    };
                    xhr_1.send();
                }
            }
            else if (targetSrc) {
                fallback(); // Fallback to original behavior
            }
        }
        else if (targetSrc) {
            fallback(); // Fallback to original behavior
        }
        function setScript(targetSrc, integrity) {
            if (isIE() && targetSrc.indexOf("ai.3") !== -1) {
                // This regex matches any URL which contains "\ai.3." but not any full versions like "\ai.3.1" etc
                targetSrc = targetSrc.replace(/(\/)(ai\.3\.)([^\d]*)$/, function (_all, g1, g2) {
                    return g1 + "ai.2" + g2;
                });
                // let message = "Load Version 2 SDK instead to support IE"; // where to report this error?
            }
            if (cfg.cr !== false) {
                for (var i = 0; i < domains.length; i++) {
                    if (targetSrc.indexOf(domains[i]) > 0) {
                        domainRetryIndex = i;
                        break;
                    }
                }
            }
            var _handleError = function (evt) {
                appInsights.queue = []; // Clear the queue
                if (!handled) {
                    // start retry
                    if (domainRetryIndex >= 0 && domainRetryCount + 1 < domains.length) { // domainRetryIndex will be negative when client using own domain (the supported domain list is defined above)
                        var nextIdx_1 = (domainRetryIndex + domainRetryCount + 1) % domains.length;
                        _createScript(targetSrc.replace(/^(.*\/\/)([\w\.]*)(\/.*)$/, function (_all, http, domain, qs) {
                            return http + domains[nextIdx_1] + qs;
                        }));
                        domainRetryCount += 1;
                    }
                    else {
                        handled = true;
                        loadFailed = true;
                        _reportFailure(targetSrc);
                    }
                }
            };
            var _handleLoad = function (evt, isAbort) {
                if (!handled) {
                    // IE10, Opera calls loaded before the script is processed.
                    // so delaying to give the script a chance to be processed
                    setTimeout(function () {
                        if (isAbort) {
                            if (isOneDS) {
                                if (typeof appInsights.isInitialized !== "function" || !appInsights.isInitialized()) {
                                    _handleError();
                                }
                            }
                            else {
                                if (!appInsights.core) {
                                    _handleError();
                                }
                            }
                        }
                    }, 500);
                }
                loadFailed = false;
            };
            function create_policy() {
                var _a;
                // Function to handle URL validation
                function validateURL(urlString) {
                    try {
                        var url = new URL(urlString);
                        if (url.host && url.host === "js.monitor.azure.com") {
                            return urlString;
                        }
                        else {
                            handleInvalidURL(urlString);
                        }
                    }
                    catch (_a) {
                        handleInvalidURL(urlString);
                    }
                }
                // Function to handle reporting failures
                function handleInvalidURL(urlString) {
                    _reportFailure("AI policy blocked URL: " + urlString);
                }
                return (_a = window.trustedTypes) === null || _a === void 0 ? void 0 : _a.createPolicy(policyName, {
                    createScriptURL: validateURL
                });
            }
            var _createScript = function (src) {
                var scriptElement = doc.createElement(scriptText);
                if (cfg.pl) {
                    if (cfg.ttp && cfg.ttp.createScript) {
                        scriptElement["src"] = cfg.ttp.createScriptURL(src);
                    }
                    else {
                        scriptElement["src"] = create_policy().createScriptURL(src);
                    }
                }
                else {
                    scriptElement["src"] = src;
                }
                if (cfg.nt) {
                    scriptElement.setAttribute("nonce", cfg.nt);
                }
                if (integrity) {
                    // Set the integrity attribute to the script tag if integrity is provided
                    scriptElement.integrity = integrity;
                }
                scriptElement.setAttribute("data-ai-name", aiName);
                // Allocate Cross origin only if defined and available
                var crossOrigin = cfg[strCrossOrigin];
                if ((crossOrigin || crossOrigin === "") && scriptElement[strCrossOrigin] != strUndefined) {
                    scriptElement[strCrossOrigin] = crossOrigin;
                }
                scriptElement.onload = _handleLoad;
                scriptElement.onerror = _handleError;
                // Some browsers support onload while others onreadystatechange and others both
                scriptElement["onreadystatechange"] = function (evt, isAbort) {
                    if (scriptElement["readyState"] === "loaded" || scriptElement["readyState"] === "complete") {
                        _handleLoad(evt, isAbort);
                    }
                };
                if (cfg.ld && cfg.ld < 0) {
                    // if user wants to append tag to document head, blocking page load
                    var headNode = doc.getElementsByTagName("head")[0];
                    headNode.appendChild(scriptElement);
                }
                else {
                    setTimeout(function () {
                        // Attempts to place the script tag in the same location as the first script on the page
                        doc.getElementsByTagName(scriptText)[0].parentNode.appendChild(scriptElement);
                    }, cfg.ld || 0);
                }
                return scriptElement;
            };
            _createScript(targetSrc);
        }
        // capture initial cookie
        try {
            appInsights.cookie = doc.cookie;
        }
        catch (e) {
            // eslint-disable-next-line no-empty
        }
        function _createMethods(methods) {
            while (methods.length) {
                (function (name) {
                    // Define a temporary method that queues-up a the real method call
                    appInsights[name] = function () {
                        // Capture the original arguments passed to the method
                        var originalArguments = arguments;
                        if (!loadFailed) { // If we have detected that the main script failed to load then stop queuing events that will never be processed
                            // Queue-up a call to the real method
                            appInsights.queue.push(function () {
                                // Invoke the real method with the captured original arguments
                                appInsights[name].apply(appInsights, originalArguments);
                            });
                        }
                    };
                })(methods.pop());
            }
        }
        if (isOneDS) {
            _createMethods(oneDsMethods);
        }
        else {
            _createMethods(aiMethod);
        }
        // expose SeverityLevel enum
        appInsights["SeverityLevel"] = {
            Verbose: 0,
            Information: 1,
            Warning: 2,
            Error: 3,
            Critical: 4
        };
        // Collect global errors
        var globalErrorCollect = false;
        if (isOneDS) {
            var autoCapture = aiConfig["webAnalyticsConfiguration"]["autoCapture"];
            if (!autoCapture || autoCapture.jsError) {
                globalErrorCollect = true;
            }
        }
        else {
            // Note: ApplicationInsightsAnalytics is the extension string identifier for
            //  AppAnalytics. It is defined in ApplicationInsights.ts:ApplicationInsights.identifer
            var analyticsCfg = ((aiConfig.extensionConfig || {}).ApplicationInsightsAnalytics || {});
            if (!(aiConfig[strDisableExceptionTracking] === true || analyticsCfg[strDisableExceptionTracking] === true)) {
                globalErrorCollect = true;
            }
        }
        if (globalErrorCollect) {
            var method_1 = "onerror";
            _createMethods(["_" + method_1]);
            var originalOnError_1 = win[method_1];
            win[method_1] = function (message, url, lineNumber, columnNumber, error) {
                var handled = originalOnError_1 && originalOnError_1(message, url, lineNumber, columnNumber, error);
                if (handled !== true) {
                    appInsights["_" + method_1]({
                        message: message,
                        url: url,
                        lineNumber: lineNumber,
                        columnNumber: columnNumber,
                        error: error,
                        evt: win.event
                    });
                }
                return handled;
            };
            aiConfig["autoExceptionInstrumented"] = true;
        }
        return appInsights;
    })(cfg.cfg);
    // global instance must be set in this order to mitigate issues in ie8 and lower
    win[aiName] = aiSdk;
    function _onInit() {
        if (cfg.onInit) {
            cfg.onInit(aiSdk);
        }
    }
    // if somebody calls the snippet twice, don't report page view again
    if (aiSdk.queue && aiSdk.queue.length === 0) {
        aiSdk.queue.push(_onInit);
        if (!isOneDS) {
            aiSdk.trackPageView({});
        }
    }
    else {
        // Already loaded so just call the onInit
        _onInit();
    }
})(window, document);
